import { render, staticRenderFns } from "./UsdcTransactionList.vue?vue&type=template&id=942e7274&scoped=true&"
import script from "./UsdcTransactionList.vue?vue&type=script&lang=ts&"
export * from "./UsdcTransactionList.vue?vue&type=script&lang=ts&"
import style0 from "./UsdcTransactionList.vue?vue&type=style&index=0&id=942e7274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942e7274",
  null
  
)

export default component.exports